import { HANDLE_API_CALL_EXCEPTION } from './actionType'

export const handleApiCallException = (error) => {
  return {
    type: HANDLE_API_CALL_EXCEPTION,
    payload: { error },
  }
}
